function MouseIcon() {
  return (
    <svg
      width="32"
      height="54"
      viewBox="0 0 32 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 30.5732L14.6666 19.9999L5.33329 19.9999C5.33329 25.4399 9.39996 29.9199 14.6666 30.5732ZM26.6666 11.9999C26.6666 6.10658 21.8933 1.33324 16 1.33324C10.1066 1.33324 5.33329 6.10658 5.33329 11.9999L5.33329 17.3332L26.6666 17.3332L26.6666 11.9999ZM17.3333 30.5732C22.6 29.9199 26.6666 25.4399 26.6666 19.9999L17.3333 19.9999L17.3333 30.5732Z"
        fill="white"
      />
      <line
        x1="16.5"
        y1="40"
        x2="16.5"
        y2="54"
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  );
}

export default MouseIcon;
